import logo256 from "@/assets/logo-256.webp";
import logo512 from "@/assets/logo-512.webp";
import logo1024 from "@/assets/logo-1024.webp";

/**
 * Merk-logo met expliciete afmetingen (geen layout shift) en een licht
 * WebP-bestand in plaats van de grote PNG. Visueel identiek aan voorheen;
 * de 1024px-variant houdt het logo scherp op telefoons met hoge pixeldichtheid.
 */
export function Logo({
  className = "h-12 w-auto sm:h-14",
  priority = false,
}: {
  className?: string;
  priority?: boolean;
}) {
  return (
    <img
      src={logo256}
      srcSet={`${logo256} 256w, ${logo512} 512w, ${logo1024} 1024w`}
      sizes="(min-width: 640px) 175px, 150px"
      alt="Taxiritje.nl"
      width={256}
      height={102}
      decoding="async"
      loading={priority ? "eager" : "lazy"}
      {...(priority ? { fetchPriority: "high" as const } : {})}
      className={className}
    />
  );
}
